$(window).scroll(function(){
    if ($(this).scrollTop() > 150) {
       $('.header-wrapper').addClass('scrolled_down');
    } else {
       $('.header-wrapper').removeClass('scrolled_down');
    }
});



$(document).ready(function(){
    $('.fec_slidee').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false, // Remove dots
        speed: 300,
        centerMode: true, // Center the slides
        centerPadding: '250px', // Ensure full width centering
        prevArrow: "<button type='button' class='slick-prev pull-left'><i class='fa fa-arrow-left' aria-hidden='true'></i></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><i class='fa fa-arrow-right' aria-hidden='true'></i></button>",
        autoplaySpeed: 5000,
        autoplay: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '50px', 
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '20px', 
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '0px', 
                  
                }
            }
        ]
    });
});





function initSlick() {
  if ($(window).width() < 992) {
    if (!$('.helping-slide-mbl').hasClass('slick-initialized')) {
      $('.helping-slide-mbl').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
          dots: true,   // Show dots
        arrows: false, // Hide arrows
        responsive: [
          {
            breakpoint: 749,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    }
  } else {
    if ($('.helping-slide-mbl').hasClass('slick-initialized')) {
      $('.helping-slide-mbl').slick('unslick'); // Destroy on desktop
    }
  }
}

// Run on load and resize
$(document).ready(initSlick);
$(window).resize(initSlick);

//HOME CUSTOM BANNER

document.addEventListener('DOMContentLoaded', function() {
  const prevArrowSvg = `<button type="button" class="slick-prev">
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.67413 0C5.67413 0.793223 5.52737 1.57868 5.24222 2.31152C4.95707 3.04436 4.53911 3.71024 4.01222 4.27113C3.48533 4.83203 2.85982 5.27695 2.17141 5.58051C1.48299 5.88406 0.745153 6.0403 1.81198e-05 6.0403V6.06591L0 6.93411L1.81198e-05 6.9597C0.745153 6.9597 1.48299 7.11594 2.17141 7.41949C2.85982 7.72305 3.48533 8.16797 4.01222 8.72886C4.53911 9.28976 4.95707 9.95564 5.24222 10.6885C5.52737 11.4213 5.67413 12.2068 5.67413 13H6.59426C6.59426 9.72344 4.50431 7.54911 1.68985 6.93411L12 6.93411L12 6.06591L1.68979 6.06591C4.50427 5.45092 6.59426 3.27658 6.59426 0L5.67413 0Z" fill="#E6E4E5"/>
    </svg>
  </button>`;

  const nextArrowSvg = `<button type="button" class="slick-next">
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.32587 0C6.32587 0.793223 6.47263 1.57868 6.75778 2.31152C7.04293 3.04436 7.46089 3.71024 7.98778 4.27113C8.51467 4.83203 9.14018 5.27695 9.82859 5.58051C10.517 5.88406 11.2548 6.0403 12 6.0403V6.06591L12 6.93411L12 6.9597C11.2548 6.9597 10.517 7.11594 9.82859 7.41949C9.14018 7.72305 8.51467 8.16797 7.98778 8.72886C7.46089 9.28976 7.04293 9.95564 6.75778 10.6885C6.47263 11.4213 6.32587 12.2068 6.32587 13H5.40574C5.40574 9.72344 7.49569 7.54911 10.3101 6.93411L7.58644e-08 6.93411L0 6.06591L10.3102 6.06591C7.49573 5.45092 5.40574 3.27658 5.40574 0L6.32587 0Z" fill="#E6E4E5"/>
    </svg>
  </button>`;

  const slider1 = $('.slider-1');
  const thumbnailSlider1 = $('.thumbnail_slider-1');

  // Initialize main and thumbnail sliders
  slider1.slick({
    arrows: true,
    prevArrow: prevArrowSvg,
    nextArrow: nextArrowSvg,
    asNavFor: thumbnailSlider1
  });

  thumbnailSlider1.slick({
    slidesToShow: 1,
    arrows: false,
    dots: true,
    asNavFor: slider1
  });

  // Track slide changes
  ['slider-1', 'thumbnail_slider-1'].forEach(sliderClass => {
    $(document).on('afterChange', `.${sliderClass}`, (e, slick, currentSlide) => {
      $(`#slide_index_${currentSlide}`).click();
    });
  });
});




$(document).ready(function(){
    if ($('.same_three_img_block').children().length > 1) {
        $('.same_three_img_block').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            speed: 300,
            prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-arrow-left' aria-hidden='true'></i></button>",
            nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-arrow-right' aria-hidden='true'></i></button>",
            autoplaySpeed: 5000,
            autoplay: true,
        });
    }
});



